import WITH_BUTTON from './withButton'
import WITHOUT_BUTTON from './withoutButton'

export default {
  WITH_BUTTON,
  WITHOUT_BUTTON
}